/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AnalysisResultFault } from './AnalysisResultFault';
import {
    instanceOfAnalysisResultFault,
    AnalysisResultFaultFromJSON,
    AnalysisResultFaultFromJSONTyped,
    AnalysisResultFaultToJSON,
} from './AnalysisResultFault';

/**
 * @type AnalysisResultDtoAirPressureFault
 * 
 * @export
 */
export type AnalysisResultDtoAirPressureFault = AnalysisResultFault;


export function AnalysisResultDtoAirPressureFaultFromJSON(json: any): AnalysisResultDtoAirPressureFault {
    return AnalysisResultDtoAirPressureFaultFromJSONTyped(json, false);
}

export function AnalysisResultDtoAirPressureFaultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDtoAirPressureFault {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...AnalysisResultFaultFromJSONTyped(json, true) };
    return  AnalysisResultFaultFromJSONTyped(json, true);
}

export function AnalysisResultDtoAirPressureFaultToJSON(value?: AnalysisResultDtoAirPressureFault | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfAnalysisResultFault(value)) {
        return AnalysisResultFaultToJSON(value as AnalysisResultFault);
    }

    return {};
}

/**
 * Check if a given object implements the AnalysisResultDtoAirPressureFault interface.
 */
export function instanceOfAnalysisResultDtoAirPressureFault(value: any): value is AnalysisResultDtoAirPressureFault {
    if (instanceOfAnalysisResultFault(value)) return true;
    return false;
}

